export const omitInheritStoryProps = [
    'id',
    'title',
    'group',
    'layout',
    'variants',
    'file',
    'slots',
    'lastSelectedVariant',
];
